module.exports = __webpack_public_path__ + "static/img/tktc.c2402ee5.png";